import type { HijriDate } from "./types";

const AR_DIGITS = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];

export function formatHijriLong(h: HijriDate): string {
  return `${h.day} ${h.monthName} ${h.year} AH`;
}

export function formatHijriShort(h: HijriDate): string {
  return `${h.day}/${h.month}/${h.year}`;
}

export function formatHijriArabic(h: HijriDate): string {
  return `${toArabicNumerals(h.day)} ${h.monthNameAr} ${toArabicNumerals(h.year)}`;
}

export function toArabicNumerals(n: number): string {
  return n
    .toString()
    .split("")
    .map((ch) => {
      const code = ch.charCodeAt(0) - 48;
      if (code < 0 || code > 9) return ch;
      return AR_DIGITS[code] ?? ch;
    })
    .join("");
}
